module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/60c7cb13fa42e621eaa9dba9ab94dc47.png";